/* eslint-disable react/jsx-filename-extension */
import { map, filter, find, get, size, includes } from 'lodash-es';
import { defaultTheme } from 'react-select';
import React from 'react';
import { StyleEnum } from './index.enum';
import { checkIsNull } from '../../Utils/utils';

/**
 * default format option label <Select>
 * @param {*} param0
 */
// eslint-disable-next-line react/prop-types
export const getFormatOptionLabelDefault = ({ label }) => <div>{label}</div>;

/**
 * get options
 * @param {*} param0
 */
export const getOptions = ({ selection }) => map(selection, item => ({ ...item, value: item.value, label: item.name }));

/**
 * get value
 * @param {*} param0
 */
export const getValue = ({ value, isMulti, options }) => {
  try {
    let result = isMulti ? [] : '';
    if (size(options) > 0 && !checkIsNull(value)) {
      if (isMulti) {
        const indexOfValue = option => value.indexOf(get(option, 'value'));
        result = filter(options, option => indexOfValue(option) >= 0);
      } else {
        result = find(options, option => get(option, 'value') === value);
      }
    }
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getValue: ${e}`);
  }
  return '';
};

/**
 * get color
 * @param {*} param0
 */
const getColor = ({ existError, showError }) => {
  if (showError) {
    return StyleEnum.COLOR_SHOW_ERROR;
  }
  if (existError) {
    return StyleEnum.COLOR_EXIST_ERROR;
  }

  return StyleEnum.COLOR_VALID;
};

/**
 * get color
 * @param {*} param0
 */
const getColorFocus = ({ existError, showError }) => {
  if (showError) {
    return StyleEnum.COLOR_SHOW_ERROR_FOCUS;
  }
  if (existError) {
    return StyleEnum.COLOR_EXIST_ERROR_FOCUS;
  }

  return StyleEnum.COLOR_VALID_FOCUS;
};

/** TODO => move to index.scss
 * custom style
 * @param {*} param0
 */
export const styleCustom = ({ width, height, existError, showError, minWidthMenu }) => {
  // container
  const container = provided => ({
    ...provided,
    width: !includes(width, 'px') ? '100%' : width, // fit-content
    minWidth: !includes(width, 'px') ? '' : width, // StyleEnum.WIDTH
    height: !includes(height, 'px') ? '' : height,
    minHeight: !includes(height, 'px') ? '' : height,
    fontSize: StyleEnum.FONT_SIZE,
    color: StyleEnum.FONT_COLOR,
  });

  // control
  const control = base => ({
    ...base,
    // width,
    height: !includes(height, 'px') ? '' : height,
    minHeight: !includes(height, 'px') ? '' : height,
    cursor: 'pointer',
    borderColor: getColor({ existError, showError }),
    '&:hover': {
      borderColor: getColor({ existError, showError }),
    },
  });

  // menu
  const menu = base => ({
    ...base,
    minWidth: minWidthMenu,
  });

  // options
  const option = base => ({
    ...base,
    minHeight: '34px',
  });

  return {
    container,
    control,
    menu,
    option,
  };
};

/** TODO => move to index.scss
 * custom theme
 * @param {*} param0
 */
export const themeCustom = ({ existError, showError }) => ({
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    primary: getColorFocus({ existError, showError }),
  },
});
